import { EmployeeHeadcountReport } from "@/pages/reporting/employee/headcount/EmployeeHeadcountReport.tsx";
import { EmployeeRetentionReport } from "@/pages/reporting/employee/retention/EmployeeRetentionReport.tsx";
import { EmployeeSalaryReportType } from "@/pages/reporting/employee/salary/employee-salary-report.types.ts";
import { PeopleAnalytics } from "@/pages/reporting/employee/people-analytics/PeopleAnalytics.tsx";
import { PeopleAnalyticsView } from "@/pages/reporting/employee/people-analytics/people-analytics.types.ts";
import { EmployeeSalaryReportV2 } from "@/pages/reporting/employee/salary-v2/EmployeeSalaryReportV2.tsx";
import { RecruitingClosingTimeReport } from "@/pages/reporting/recruiting/closing-time/RecruitingClosingTimeReport.tsx";
import { DisqualificationReasonsReport } from "@/pages/reporting/recruiting/disqualification-reasons/DisqualificationReasonsReport.tsx";
import { RecruitingSourceEfficiencyReport } from "@/pages/reporting/recruiting/source-efficiency/RecruitingSourceEfficiencyReport.tsx";
import { RecruitingStageFlowReport } from "@/pages/reporting/recruiting/stage-flow/RecruitingStageFlowReport.tsx";
import Reporting from "@/pages/reporting/Reporting.tsx";
import { reportingModulePermissions } from "@/pages/reporting/reporting.types.ts";
import { RouteConfig } from "@/routes/types/route.types.ts";
import { ApiPermission } from "@/types/role.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";

export const reportsRoutes: RouteConfig[] = [
  {
    path: "/reporting",
    anyOfPermissions: reportingModulePermissions,
    children: [
      { path: "", element: <Reporting /> },
      {
        path: "recruiting",
        planFeature: ApiFeatureType.ats,
        children: [
          {
            path: "stage-flow-report",
            element: <RecruitingStageFlowReport />,
            allOfPermissions: [ApiPermission.reporting_recruiting_stage_flow],
          },
          {
            path: "closing-time-report",
            element: <RecruitingClosingTimeReport />,
            allOfPermissions: [ApiPermission.reporting_recruiting_closing_time],
          },
          {
            path: "source-efficiency-report",
            element: <RecruitingSourceEfficiencyReport />,
            allOfPermissions: [ApiPermission.reporting_recruiting_source_efficiency],
          },
          {
            path: "disqualification-reasons-report",
            element: <DisqualificationReasonsReport />,
            allOfPermissions: [ApiPermission.reporting_recruiting_disqualification_reasons],
          },
        ],
      },
      {
        path: "employee",
        children: [
          {
            path: "headcount-report",
            redirect: "/reporting/employee/headcount-report-analytics",
          },
          {
            path: "headcount-report-analytics",
            element: <EmployeeHeadcountReport />,
            allOfPermissions: [ApiPermission.reporting_employee_headcount],
          },
          {
            path: "retention-report",
            redirect: "/reporting/employee/retention-report-analytics",
          },
          {
            path: "retention-report-analytics",
            element: <EmployeeRetentionReport />,
            allOfPermissions: [ApiPermission.reporting_employee_retention],
          },
          {
            path: "salary-report",
            redirect: "/reporting/employee/salary-report-analytics",
          },
          {
            path: "salary-report/table",
            redirect: "/reporting/employee/salary-report-analytics/table",
          },
          {
            path: "salary-report/graphs",
            redirect: "/reporting/employee/salary-report-analytics/graphs",
          },
          {
            path: "salary-report-v2",
            redirect: "/reporting/employee/salary-report-analytics",
          },
          {
            path: "salary-report-v2/table",
            redirect: "/reporting/employee/salary-report-analytics/table",
          },
          {
            path: "salary-report-v2/graphs",
            redirect: "/reporting/employee/salary-report-analytics/graphs",
          },
          {
            path: "salary-report-analytics",
            element: <EmployeeSalaryReportV2 type={EmployeeSalaryReportType.graphs} />,
            allOfPermissions: [ApiPermission.reporting_employee_salary],
          },
          {
            path: "salary-report-analytics/graphs",
            element: <EmployeeSalaryReportV2 type={EmployeeSalaryReportType.graphs} />,
            allOfPermissions: [ApiPermission.reporting_employee_salary],
          },
          {
            path: "salary-report-analytics/table",
            element: <EmployeeSalaryReportV2 type={EmployeeSalaryReportType.table} />,
            allOfPermissions: [ApiPermission.reporting_employee_salary],
          },
          {
            path: "people-analytics",
            element: <PeopleAnalytics view={PeopleAnalyticsView.table} />,
            allOfPermissions: [ApiPermission.reporting_people_analytics],
          },
          {
            path: "people-analytics/chart",
            element: <PeopleAnalytics view={PeopleAnalyticsView.chart} />,
            allOfPermissions: [ApiPermission.reporting_people_analytics],
          },
        ],
      },
    ],
  },
];
